/**
* @name: left-layout-div
* @author: weiyong
* @date: 2023-05-11 18:01
* @description：left-layout-div
* @update: 2023-05-11 18:01
*/
<template>
  <div :class="[prefixCls,openFlag?'is-opened':'is-not-opened',getMenuTheme]"
       class="side-menu h100b" :style="'--el-custom-sidebar-bg-color:'+getMenuBgColor">
     <ul class="el-custom-sidebar  el-custom--sidebar-vertical h100b" :class="openFlag?'el-custom-not-sidebar--collapse':'el-custom-sidebar--collapse'" style="padding-top: 2px;">
<!--       缩小菜单-->
        <collapse-menu :openFlag="openFlag"/>
     </ul>

<!--    <i class="el-icon el-custom-sidebar__icon-arrow collapse-button " @click="openClick" :class="openFlag?'is-opened':'is-not-opened'">-->
<!--      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" v-if="openFlag">-->
<!--        <path fill="currentColor" d="M609.408 149.376 277.76 489.6a32 32 0 0 0 0 44.672l331.648 340.352a29.12 29.12 0 0 0 41.728 0 30.592 30.592 0 0 0 0-42.752L339.264 511.936l311.872-319.872a30.592 30.592 0 0 0 0-42.688 29.12 29.12 0 0 0-41.728 0z"></path>-->
<!--      </svg>-->
<!--      <svg xmlns="http://www.w3.org/2000/svg" v-if="!openFlag" viewBox="0 0 1024 1024"><path fill="currentColor" d="M340.864 149.312a30.592 30.592 0 0 0 0 42.752L652.736 512 340.864 831.872a30.592 30.592 0 0 0 0 42.752 29.12 29.12 0 0 0 41.728 0L714.24 534.336a32 32 0 0 0 0-44.672L382.592 149.376a29.12 29.12 0 0 0-41.728 0z"></path>-->
<!--      </svg>-->
<!--    </i>-->
<!--    -->
    <div class="menu-panel-bar">
      <div class="icon-div"  @click="openClick" >
        <menu-fold-outlined v-if="openFlag"/>
        <menu-unfold-outlined v-if="!openFlag"/>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "left-layout-div",
});
</script>

<script lang="ts" setup>
import {MenuFoldOutlined,MenuUnfoldOutlined} from "@ant-design/icons-vue";
import CollapseMenu from "./collapse-menu.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import GoingUtils from "@/utils/goingUtils";
import {useMenuSetting} from "@/hooks/setting/useMenuSetting";

const {prefixCls} = useDesign('environmental-left-layout-div');

const {
  getMenuBgColor,
  getMenuTheme,
  getCollapsed,
  getSplit,
} = useMenuSetting();

const openFlag=ref(GoingNewUtils.parseBoolean(StorageUtils.getItem("openFlag")+""));
const openClick=()=>{
  openFlag.value=!openFlag.value;
  StorageUtils.addItem("openFlag",unref(openFlag));
}
</script>

<style type="text/css" lang="less" scoped>
@prefix-cls: ~'@{namespace}-environmental-left-layout-div';

.@{prefix-cls} {
  &.side-menu{
    z-index: 101;
    position: sticky;
    background-color: var(--primary-color,#065979);
    overflow: hidden;

    .menu-panel-bar{
      position: absolute;
      background-color: var(--el-custom-sidebar-bg-color,#1BA57C);
      bottom: 0;
      height: 48px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      left: 0;
      padding: 0;
      z-index: 20;
      box-sizing: border-box;

      .icon-div{
        border-radius: 4px;
        cursor: pointer;
        background-color: rgba(247, 248, 250, 0.12);
        width: 24px;
        height: 24px;
        color: #FFF;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }
    }
  }

  &.is-opened{
    .collapse-button{
      left: calc(var(--left-menu-width,205px) - 8px);
    }
  }

  // light 主题：折叠按钮用主色底，保证展开/折叠都可见
  &.light {
    .menu-panel-bar {
      background-color: #fff;
      border-top: 1px solid #eee;

      .icon-div {
        background-color: var(--primary-color, #1ba57c);
        color: #fff;
      }
    }
  }

  &.dark {
    .menu-panel-bar {
      .icon-div {
        background-color: rgba(247, 248, 250, 0.18);
        color: #fff;
      }
    }
  }

  .el-custom-sidebar{
    list-style: none;
    position: relative;
    padding-left: 0;
    background: var(--el-custom-sidebar-bg-color);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    transition: all .2s;
    height: calc(100% - 48px);
    overflow-x: hidden;
    overflow-y: auto;
  }

  // 与大海深蓝一致：折叠宽度 48px
  .el-custom-sidebar--collapse{
    width: 48px;
  }

  &.is-not-opened {
    width: 48px;

    .menu-panel-bar {
      display: flex !important;
      justify-content: center;
      padding: 0;
      width: 48px;
    }
  }

  .el-custom--sidebar-vertical:not(.el-custom-sidebar--collapse) {
    width: var(--left-menu-width,205px);
  }

  .collapse-button {
    top: 64px;
    width: 18px;
    height: 18px;
    color: #5e5e5e;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 100%;
    position: absolute;
    left: 90%;
    cursor:pointer;
    &.el-icon svg {
      height: 0.8em;
      width: 0.8em;
    }
  }
}

</style>
